import { useEffect } from 'react'

import { trackGTMEvent } from '../config/analytics'
import { TopStory } from '../types'

const useStoryPageTracking = (story: TopStory) => {
  useEffect(() => {
    const categories = story.categories.length ? story.categories.map(category => category.name) : 'No category'
    const authors = story.authorsData.map(author => author.name)
    trackGTMEvent.gaStoryPageVisit({ categories, authors })
  }, [story])
}

export default useStoryPageTracking
